import { createSelector } from 'reselect';

const populateTimeTrackerLog = timeTrackerLog => timeTrackerLog;

export default createSelector(state => state.timeTrackerLog, populateTimeTrackerLog);
